import Button from "@app/components/button"
import GradientContainer from "@app/components/gradient/gradient-container"
import ScheduleDemo from "@app/components/schedule-demo";

const MobileFindYourPlan = () => (
  <div className="w-full flex justify-center mt-4">
    <GradientContainer
      overrideClassName="z-0 w-[90%] rounded-2xl -mb-20"
    >
      <div className="flex flex-col sm-3:justify-between md:space-y-0 sm-3:flex-row md:space-x-2 py-14 px-10
       space-y-4 sm:space-y-3 items-center sm:items-start sm-3:items-center md:items-center w-full">
        <div className="flex h5 xs:h4 flex-col text-light">
          <p>Find your plan.</p>
          <p>Explore our options.</p>
        </div>
        <div className="flex w-full sm:w-auto justify-center sm-3:pt-3 md:pt-0 ">
          <ScheduleDemo>
            {(setIsModalOpen) => <Button size="base" full className="!bg-light !text-md xl:!text-lg !rounded-md !text-gray-700" onClick={() => setIsModalOpen(true)}>Schedule Demo</Button>}
          </ScheduleDemo>
        </div>
      </div>
    </GradientContainer>
  </div>
)

export default MobileFindYourPlan;